// extracted by mini-css-extract-plugin
export default {"cvError":"a1-z"};